import { CALENDAR_EVENTS, CONTACTS, USERS } from "./apiMethods";
import { STUDIO_B_RESOURCE_ID, STUDIO_A_RESOURCE_ID } from "./constants";
const convertTimeInLocalToCST = require("../helpers/getNashvilleTime");

const date = new Date();
const cst = convertTimeInLocalToCST(date);
const offset = date.getTimezoneOffset() / 60 + cst.offset;

const DAY_START = `09:00:00-0${offset}:00`;
const DAY_END = `22:00:00-0${offset}:00`;
const MIN_TIME_INTERVOL = 0.5;

const log_on = true;

const log = (input) => {
  if (log_on) console.log(input);
};

const myNewDate = (date) => {
  let newDate = new Date(date);
  if (!isNaN(newDate)) return newDate;
  return new Date(date.replace(" ", "T"));
};

const getUserIds = (userList) => {
  const ids = [];
  for (let j = 0; j < userList.length; j++) {
    ids.push(userList[j].id);
  }

  return ids;
};
const getResourceIds = (resourceList) => {
  const ids = [];
  for (let j = 0; j < resourceList.length; j++) {
    ids.push(resourceList[j].resource_id);
  }

  return ids;
};
const getEvents = async (from, to) => {
  const calendarEvents = await CALENDAR_EVENTS.list(from, to);

  //console.log(calendarEvents);

  const newCalendarEvents = [];
  for (let i = 0; i < calendarEvents.length; i++) {
    const calendarEvent = await CALENDAR_EVENTS.view(calendarEvents[i].event_id);
    newCalendarEvents.push({});
    newCalendarEvents[i].event_name = calendarEvent.event_name;
    newCalendarEvents[i].event_id = calendarEvent.event_id;
    newCalendarEvents[i].activity_type = calendarEvent.activity_type;
    newCalendarEvents[i].activity_id = calendarEvent.activity_id;
    newCalendarEvents[i].start_datetime = calendarEvent.start_datetime;
    newCalendarEvents[i].end_datetime = calendarEvent.end_datetime;
    newCalendarEvents[i].duration_actual = calendarEvent.duration_actual;
    newCalendarEvents[i].cal_user = calendarEvent.cal_user
      ? getUserIds(calendarEvent.cal_user)
      : null;
    newCalendarEvents[i].resources = calendarEvent.resources
      ? getResourceIds(calendarEvent.resources)
      : null;
  }

  return newCalendarEvents;
};

const getTimeSlots = (free, duration) => {
  const availableTimeSlots = [];
  for (let k = 0; k < free.length; k++) {
    const freePeriodDuration = free[k].duration;
    const freePeriodStart = myNewDate(free[k].start);
    const freePeriodEnd = myNewDate(free[k].end);
    for (let l = 0; l < freePeriodDuration / MIN_TIME_INTERVOL; l++) {
      const timeSlotStart = myNewDate(
        freePeriodStart.getTime() + MIN_TIME_INTERVOL * l * 3600000
      );
      const timeSlotEnd = myNewDate(timeSlotStart.getTime() + duration * 3600000);
      if (timeSlotEnd <= freePeriodEnd) {
        availableTimeSlots.push({
          start: timeSlotStart,
          end: timeSlotEnd
        });
      }
    }
  }

  return availableTimeSlots;
};

const checkForOverlap = (busyIn) => {
  for (let i = 0; i < busyIn.length; i++) {
    const start = myNewDate(busyIn[i].start);
    const end = myNewDate(busyIn[i].end);

    for (let j = 0; j < busyIn.length; j++) {
      if (j !== i && !busyIn[i].evaluated) {
        const start2 = myNewDate(busyIn[j].start);
        const end2 = myNewDate(busyIn[j].end);

        if ((start > start2 && end > start2) || (start < end2 && end < end2)) {
        } else {
          busyIn[i].start =
            busyIn[i].start < busyIn[j].start ? busyIn[i].start : busyIn[j].start;
          busyIn[i].end =
            busyIn[i].end > busyIn[j].end ? busyIn[i].end : busyIn[j].end;
          busyIn[j].evaluated = true;
          if (busyIn[j].resources) {
            if (busyIn[i].resources) {
              for (let k = 0; k < busyIn[j].resources; k++) {
                if (!busyIn[i].resources.includes(busyIn[j].resources[k])) {
                  busyIn[i].resources.push(busyIn[j].resources[k]);
                }
              }
            } else {
              busyIn[i].resources = busyIn[j].resources;
            }
          }
        }
      }
    }
  }

  const busyOut = [];
  for (let j = 0; j < busyIn.length; j++) {
    if (!busyIn[j].evaluated) {
      busyOut.push(busyIn[j]);
    }
  }

  return busyOut;
};

const getFreePeriods = (busy, date) => {
  const free = [];
  const dayStart = myNewDate(`${date}T${DAY_START}`);
  const dayEnd = myNewDate(`${date}T${DAY_END}`);

  busy = busy.sort((a, b) => myNewDate(a.start) - myNewDate(b.start));
  busy = checkForOverlap(busy);

  for (let i = 0; i < busy.length; i++) {
    let start = myNewDate(busy[i].start);
    start = myNewDate(start.getTime() - 0.5 * 3600000);
    let end = myNewDate(busy[i].end);
    end = myNewDate(end.getTime() + 0.5 * 3600000);

    let previousEnd = busy[i - 1] ? myNewDate(busy[i - 1].end) : null;
    previousEnd = previousEnd
      ? myNewDate(previousEnd.getTime() + 0.5 * 3600000)
      : null;

    if (i === 0 && start > dayStart) {
      free.push({ start: `${date}T${DAY_START}`, end: start.toString() });
    } else if (i > 0 && previousEnd < start) {
      free.push({ start: previousEnd.toString(), end: start.toString() });
    }

    if (!busy[i + 1] && end < dayEnd) {
      free.push({ start: end.toString(), end: `${date}T${DAY_END}` });
    }
  }

  for (let i = 0; i < free.length; i++) {
    const start = myNewDate(free[i].start);
    const end = myNewDate(free[i].end);
    console.log(free[i].start);
    console.log(free[i].end);
    console.log(start);
    console.log(end);
    free[i].duration = (end - start) / 3600000;
    console.log(free[i].duration);
  }

  return { free, busy };
};

export const getAvailableTimeSlots = async (user, duration, date) => {
  user = Number(user);
  duration = Number(duration);

  const resources = [
    { name: "Studio A", id: STUDIO_A_RESOURCE_ID, busy: [], free: [] },
    { name: "Studio B", id: STUDIO_B_RESOURCE_ID, busy: [], free: [] }
  ];
  const users = await USERS.list();
  //console.log(users);
  const events = await getEvents(`${date}T${DAY_START}`, `${date}T${DAY_END}`);
  const userAvailabilities = [];

  log(events);

  for (let i = 0; i < users.length; i++) {
    userAvailabilities.push({
      full_name: users[i].full_name,
      id: users[i].id,
      busy: [],
      free: []
    });

    for (let j = 0; j < events.length; j++) {
      if (events[j].cal_user.includes(users[i].id)) {
        userAvailabilities[i].busy.push({
          start: events[j].start_datetime,
          end: events[j].end_datetime,
          resources: events[j].resources
        });
      }
    }
  }

  for (let i = 0; i < resources.length; i++) {
    for (let j = 0; j < events.length; j++) {
      if (events[j].resources && events[j].resources.includes(resources[i].id)) {
        resources[i].busy.push({
          start: events[j].start_datetime,
          end: events[j].end_datetime
        });
      }
    }
  }

  for (let i = 0; i < userAvailabilities.length; i++) {
    if (userAvailabilities[i].busy[0]) {
      const { free, busy } = getFreePeriods(userAvailabilities[i].busy, date);
      userAvailabilities[i].free = free;
      userAvailabilities[i].busy = busy;
    } else {
      userAvailabilities[i].free = [
        {
          start: `${date} ${DAY_START}`,
          end: `${date} ${DAY_END}`,
          duration: 13
        }
      ];
    }

    userAvailabilities[i].available_time_slots = getTimeSlots(
      userAvailabilities[i].free,
      duration
    );
  }

  log(userAvailabilities);

  for (let i = 0; i < resources.length; i++) {
    if (resources[i].busy[0]) {
      const { free, busy } = getFreePeriods(resources[i].busy, date);
      resources[i].free = free;
      resources[i].busy = busy;
    } else {
      resources[i].free = [
        {
          start: `${date} ${DAY_START}`,
          end: `${date} ${DAY_END}`,
          duration: 13
        }
      ];
    }

    resources[i].available_time_slots = getTimeSlots(resources[i].free, duration);
  }

  log(resources);

  /** 
  for (let i = 0; i < userAvailabilities.length; i++) {
    console.log(userAvailabilities[i].full_name);
    console.log("busy", userAvailabilities[i].busy);
    console.log("free", userAvailabilities[i].free);
    console.log("available time slots", userAvailabilities[i].available_time_slots);
  }

  for (let i = 0; i < resources.length; i++) {
    console.log(resources[i].name);
    console.log("busy", resources[i].busy);
    console.log("free", resources[i].free);
    console.log("available time slots", resources[i].available_time_slots);
  }
  */

  const producer = userAvailabilities.filter((el) => el.id === user)[0];
  //console.log(producer);
  //console.log(resources[0]);
  //console.log(resources[1]);

  const overlapAvailabilities = [];

  for (let i = 0; i < producer.available_time_slots.length; i++) {
    const producerTimeSlot = producer.available_time_slots[i];

    for (let j = 0; j < resources.length; j++) {
      for (let k = 0; k < resources[j].available_time_slots.length; k++) {
        const studioTimeSlot = resources[j].available_time_slots[k];

        if (producerTimeSlot.start.toString() === studioTimeSlot.start.toString()) {
          overlapAvailabilities.push({
            name: resources[j].name,
            id: resources[j].id,
            start: studioTimeSlot.start,
            end: studioTimeSlot.end
          });
        }
      }
    }
  }

  log(overlapAvailabilities);

  return overlapAvailabilities;
};

export const searchContacts = async (email) => {
  const contactList = await CONTACTS.list(email);

  let output = null;

  if (contactList[0]) {
    const id = contactList[0].contact_id;
    const contact = await CONTACTS.view(id);

    const customFields = contact.custom_fields;

    let artistName = null;

    for (let j = 0; j < customFields.length; j++) {
      if (customFields[j].id === "c_artistname") {
        artistName = customFields[j].value;
        break;
      }
    }

    output = {
      contact_id: id,
      artist_name: artistName,
      name: contact.search_name,
      email: contact.means_of_contact.email[0]
    };
  }

  //console.log(output);

  return output;
};
